export default class IframeReloader {
  constructor(controller) {
    this.controller = controller
  }

  reloadPreviewIframe() {
    const previewIframe = document.querySelector('iframe.preview')
    if (previewIframe) {
      const currentSrc = previewIframe.src
      previewIframe.src = ''
      // Small delay to ensure the iframe is cleared before reloading
      setTimeout(() => {
        previewIframe.src = currentSrc
      }, 100)
    }
  }
}
